import { CreateActivityComponent } from './activity/components/create/create.component';

import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { GetComponent } from './work-flow/components/get/get.component';
import { CreateWorkFlowComponent } from './work-flow/components/create/create.component';
import { CreatePhaseComponent } from './phase/components/create/create.component';
import { WorkFlowComponent } from './work-flowComponent';
import { GetRequestsComponent } from './requests/components/get-requests/get-requests.component';
import { EditPhaseComponent } from './phase/components/edit/edit.component';
import { WorkflowDetailsComponent } from './work-flow/components/workflow-details/workflow-details.component';
const routes: Routes = [
  {
    path: '',
    component: WorkFlowComponent,
    children: [
      {
        path: '',
        component: GetComponent,
      },
      {
        path: 'new',
        component: CreateWorkFlowComponent,
      },
      {
        path: 'phases/new/:id',
        component: CreatePhaseComponent,
      },
      {
        path: 'activity/new/:id',
        component: CreateActivityComponent,
      },
      {
        path: 'requests',
        component: GetRequestsComponent,
      },
      {
        path: 'phase/edit/:id',
        component: EditPhaseComponent,
      },
      {
        path: 'detail/:id',
        component: WorkflowDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkFlowRoutingModule {}
